import React from 'react';
import { t } from 'Src/i18n';
import { formatDate } from 'Utils/date/dateUtils';
import { Button } from 'Components/frameworks/button/Button';
import { Capsule } from 'Components/frameworks/capsule/Capsule';
import { DateSummary } from 'Components/widgets/package/price/DateSummary';
import { Flipper } from 'Components/frameworks/flipper/Flipper';
type Props = {
  buttonLabel: string;
  className?: string;
  onSubmit: (args: any) => void;
  suggestion: Readonly<{
    price: Readonly<{
      total: string;
    }>;
    resortArrivalDate: string;
    resortDepartureDate: string;
  }>;
  title?: Node;
};
export const AlternativeSuggestionCriteria = ({
  buttonLabel,
  className,
  onSubmit,
  suggestion,
  title,
}: Props) => {
  const getFormattedDate = formatDate('D MMMM YYYY');
  return (
    <div className={className} data-testid="AlternativeDateSuggestionCriteria">
      {title && <p className="mb-5 text-16 text-black">{title}</p>}
      <Capsule contentClassName="flex flex-col gap-10 p-20">
        <DateSummary
          template={t('booking.counterProposalPopIn.fromTo')}
          values={{
            arrivalDate: getFormattedDate(suggestion.resortArrivalDate, 'YYYYMMDD') || '',
            departureDate: getFormattedDate(suggestion.resortDepartureDate, 'YYYYMMDD') || '',
          }}
        />
        <div className="flex items-center justify-center gap-10 font-bold text-sienna">
          <Flipper value={suggestion.price.total} />
          <Flipper value={t('booking.priceDetails.packagePrice.totalPrice')} />
        </div>
        <Button
          className="w-full"
          data-testid="AlternativeProposalsModalButton"
          onClick={() => onSubmit(suggestion.resortArrivalDate)}
        >
          {buttonLabel}
        </Button>
      </Capsule>
    </div>
  );
};
